import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

const SuperAdminRoute = ({ children }) => {
  const { user, isAuthenticated } = useAuthStore();

  // Wait for user data to load before checking roles
  if (isAuthenticated && !user) {
    return null;
  }

  const isSuperAdmin = user?.roles?.includes("SUPER_ADMIN");

  if (!isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default SuperAdminRoute;
